

import axios from 'axios'
import { Message } from 'element-ui'
import md5 from 'md5'
import {
  BaseUrl
} from './baseUrl'
// 统一请求路径前缀
// const base = '/ccma-server/api'   // 服务器地址/
const base = BaseUrl()  // 本地///

// 超时设定
axios.defaults.timeouttimeout = 15000

axios.interceptors.request.use(config => {
  return config
}, err => {
  Message.error('请求超时')
  return Promise.reject(err)
})
var md5Util = md5;
let tokenSecret = 'KCKOSNFUONTLFSTGQWZXBRHINHYYVEMZ'
let timestamp;
let token;
timestamp = new Date().getTime()
token = md5Util(tokenSecret + timestamp)

export const getRequest = (url, params) => {
  return axios({
    method: 'get',
    url: `${base}${url}`,
    params: params,
    headers: {
      'Authorization': localStorage.getItem('shangke_token') || ''
    }
  })
}

export const postRequest = (url, params) => {
  let data = ''
  for (let it in params) {
    data += encodeURIComponent(it) + '=' + encodeURIComponent(params[it]) + '&'
  }
  return axios({
    method: 'post',
    url: `${base}${url}`,
    data: data,
    headers: {
      'timestamp': timestamp,
      'token': token,
      'sourceFrom': 0,
      'channelNo': localStorage.getItem('c_no') ||  sessionStorage.getItem('c_no') || '',
      'Authorization': localStorage.getItem('shangke_token') || ''
    }
  })
}
